require('./app.js');



// WEBPACK FOOTER //
// ./scripts/index.js